import React from 'react';
import { TreeStates } from '@atlassiansox/confluence-table-tree';
import EmptyState from '../../empty-state/connected';
import PageTreeUnknownError from '../../project-pages-improvement/error-states/page-tree-unknown-error';
import { PageTreeSkeleton } from '../page-tree-skeleton';

export const PageTreePlaceholder = ({ treeState }: { treeState: TreeStates | null }) => {
	switch (treeState) {
		case TreeStates.Empty:
			return <EmptyState />;
		case TreeStates.Error:
			return <PageTreeUnknownError />;
		case TreeStates.Loading:
			return <PageTreeSkeleton />;
		default:
			return null;
	}
};
